import { rtaNames } from '../../components/common/FatcaCheck.types';
import { SignupPayload } from './login';

export const FETCH_PORTFOLIOS = 'FETCH_PORTFOLIOS';
export const FETCH_PORTFOLIOS_SUCCESS = 'FETCH_PORTFOLIOS_SUCCESS';

export const GET_AMC_DETIALS = 'GET_AMC_DETIALS';

export const GET_KYC_VERIFIED = 'GET_KYC_VERIFIED';
export const GET_KYC_VERIFIED_SUCCESS = 'GET_KYC_VERIFIED_SUCCESS';
export const GET_KYC_VERIFIED_FAILED = 'GET_KYC_VERIFIED_FAILED';

export const PAN_SEED_CHECK = "PAN_SEED_CHECK";
export const PAN_SEED_CHECK_SUCCESS = "PAN_SEED_CHECK_SUCCESS";

export const SET_KYC_REGISTRATION_POPUP = 'SET_KYC_REGISTRATION_POPUP';

export const GET_UNCLAIMED_PAYOUTS = 'GET_UNCLAIMED_PAYOUTS';
export const GET_UNCLAIMED_PAYOUTS_SUCCESS = 'GET_UNCLAIMED_PAYOUTS_SUCCESS';

export const GET_FATCA_STATUS_SUCCESS = 'GET_FATCA_STATUS_SUCCESS';
export const GET_FATCA_STATUS_FAILED = 'GET_FATCA_STATUS_FAILED';
export const GET_FATCA_STATUS = 'GET_FATCA_STATUS';

export interface LIST_PROTFOLIO_PAYLOAD extends SignupPayload {
    reqId: string;
    statementHoldingFilter?: string;
}

export interface FORGOT_QA_LIST_PAYLOAD {
    reqId: string;
    userId: string;
    action: string;
}

export interface SUMMARY_INFO_RESPONSE {
    amc: string;
    amcName: string;
    currentMktValue: number;
    costValue: number;
    gainLoss: number;
    gainLossPercentage: number;
    isDemat: 'Y' | 'N';
}

// export type TaxStatus = 'INDIVIDUAL'| 'MINOR' | 'ON BEHALF OF MINOR'| 'RI' | 'NRI'| null | ''
export type TaxStatus = string;
export type ModeOfHolding =
    | 'SINGLE'
    | 'ANYONE/SURVIVOR'
    | 'EITHER/SURVIVOR'
    | 'ANYONE OR SURVIVOR'
    | 'EITHER OR SURVIVOR'
    | '';
export interface SCHEMES_RESPONSE {
    amc: string;
    amcName: string;
    nomineeStatus: string;
    folio: string;
    exchangeFolio: string;
    rtaName: rtaNames;
    fundAmcCode: string;
    schemeCode: string;
    schemeName: string;
    assetType: 'EQUITY' | 'DEBT' | 'LIQUID' | '';
    stpAllow: IsAllow;
    swpAllow: IsAllow;
    schemeType: 'EQUITY' | 'DEBT' | 'LIQUID';
    schemeSubType?: 'EQUITY' | 'DEBT' | 'LIQUID';
    closingBalance: string | number | null;
    availableUnits: string | number;
    availableAmount: string | number;
    currentMktValue: string | number;
    costValue: string | number;
    gainLoss: string | number;
    gainLossPercentage: number;
    nav?: number;
    navDate?: Date;
    mobile?: string;
    email?: string;
    modeOfHolding?: ModeOfHolding;
    investorName?: string;
    transactionSource?: string;
    schemeOption?: 'IDCW PAYOUT' | 'IDCW REINVEST' | 'REINVESTMENT' | 'PAYOUT' | null;
    taxStatus: TaxStatus;
    age?: number;
    idcwChangeAllowed?: 'True' | 'False' | null;
    dob?: string | Date | null;
    lienUnitsFlag: 'Y' | 'N';
    isDemat?: 'Y' | 'N';
    bank?: bankDetailType;
    sipAllow?: IsAllow;
    isin: string;
    swtAllow?: IsAllow;
    planMode?: PlanTypes;
    newFolio?: IsAllow;
}
type bankDetailType = {
    accountNo: string;
    accountType: string;
    name: string;
    branch: string;
    city: string;
    pincode: number;
    micr: string;
    ifsc: string;
    neftIfsc: string;
};
export interface PORTFOLIO_RESPONSE {
    currentMktValue: number;
    costValue: number;
    gainLoss: number;
    gainLossPercentage: number;
}
export interface PORTFOLIO_DATA_RESPONSE {
    summary: {
        [key: string]: SUMMARY_INFO_RESPONSE;
    };
    schemes: SCHEMES_RESPONSE[];
}

export interface PORTFOLIO_RESPONSE_PAYLOAD {
    data: PORTFOLIO_DATA_RESPONSE[];
    portfolio?: PORTFOLIO_RESPONSE;
}

interface PortFolios {
    type: typeof FETCH_PORTFOLIOS_SUCCESS;
    body: PORTFOLIO_RESPONSE;
}
export interface UNCLAIMED_PAYOUTS_RESPONSE {
    reqId: string;
    pan: string;
    perkn: string;
    mobile: string;
    success: UNCLAIMED_PAYOUTS_DATA[];
}
export interface UNCLAIMED_PAYOUTS_DATA {
    amc: string;
    folio: number;
    schemeDescription: string;
    transactionType: string;
    amount: number;
    duration: UNCLAIMED_PAYOUTS_DURATION[];
    amcName?: string;
}
export interface UNCLAIMED_PAYOUTS_DURATION {
    amount: number;
    fromPeriod: number;
    toPeriod: number;
}
export interface UNCLAIMED_PAYOUT_PAYLOAD {
    reqId: string;
    pan: string;
    pekrn: string;
    mobile: string;
}
interface UnclaimedPayouts {
    type: typeof GET_UNCLAIMED_PAYOUTS_SUCCESS;
    body: UNCLAIMED_PAYOUTS_RESPONSE;
}
export type PORTFOLIOS = PortFolios;
export type UNCLAIMED_PAYOUTS = UnclaimedPayouts;

export enum IsAllow {
    'YES' = 'Y',
    'No' = 'N',
}

export enum isKYCVerified {
    'YES' = 'Verified',
    'No' = '',
}

export enum PlanTypes {
    Reggular = 'REGULAR',
    Direct = 'DIRECT',
    R = 'R',
    D = 'D',
}

export type AccountTypeLabel = keyof typeof AccountTypes;

export enum AccountTypes {
    SAVINGS = 'SB',
    CURRENT = "CUR",
    NRO = 'NRO',
    NRI = 'NRI',
}

export const getAccountType = (value: AccountTypes): AccountTypeLabel => {
    switch (value) {
        case AccountTypes.SAVINGS:
            return 'SAVINGS';
        case AccountTypes.CURRENT:
        return 'CURRENT';
        case AccountTypes.NRO:
            return 'NRO';
        default:
            return 'SAVINGS';
    }
};
